@if (questionData) {
  @if (hasMediaCta()) {
    <media-cta [data]="questionData"></media-cta>
  }
  @if (
    {
      showTitle:
        questionData.showTitle &&
        !!(questionData.title | translateText: 'title' : questionData | formatText) &&
        questionData.type !== Questions.AI_INTERVIEWER &&
        questionData.type !== Questions.ESKO_WHY_FINDER,
      isRequired: questionData.required,
    };
    as conditions
  ) {
    <div
      class="z-texts-question z-title-text"
      [class.z-visible]="conditions.showTitle || conditions.isRequired"
      [style.color]="(ss.colors | async).text"
      [labelOverflow]="Questions.slider(questionData) ? 'header' : ''"
    >
      @if (conditions.showTitle || conditions.isRequired) {
        <span class="z-question-title">
          <span>
            <span>
              @if (conditions.showTitle) {
                <div class="z-fx z-fx-gap-8">
                  @if (no) {
                    <span class="z-fx-none z-question-title-number">{{ !!no ? no + '. ' : '' }}</span>
                  }
                  <span
                    class="z-question-title-text z-fx-flex"
                    style="white-space: pre-line"
                    [innerHtml]="questionData.title | translateText: 'title' : questionData | formatText | safeHtml"
                  ></span>
                </div>
              }
              @if (conditions.isRequired) {
                <mat-icon fontSet="zefplayer" class="z-mandatory-icon">mandatory</mat-icon>
              }
            </span>
          </span>
        </span>
      }
    </div>
  }
  <div class="z-fx z-widget-box">
    @switch (questionData.type) {
      @case (Questions.SLIDER_2D) {
        <slider-2d
          class="z-fx-auto z-fx-col z-fx-start-center"
          [ngClass]="'z-size-' + (ss.viewSize | async)"
          [no]="no"
          [questionData]="questionData"
          [groupData]="groupData | async"
          [answerValue]="answerValue | sliderAnswer"
          [isActive]="active"
          (answerValueReady)="onAnswerReady()"
          (answerValueChange)="onAnswerChange($event ? $event.join(';') : null)"
        ></slider-2d>
      }
      @case (Questions.SLIDER_1D) {
        <slider-1d
          class="z-fx-auto z-fx-col z-fx-start-center"
          [ngClass]="'z-size-' + (ss.viewSize | async)"
          [no]="no"
          [questionData]="questionData"
          [groupData]="groupData | async"
          [answerValue]="answerValue | sliderAnswer"
          (dragChange)="dragChange.emit($event)"
          (answerReady)="onAnswerReady()"
          (answerChange)="onAnswerChange($event ? $event.toString() : null)"
        ></slider-1d>
      }
      @case (Questions.SLIDER_1V) {
        <slider-1d
          class="z-fx-auto z-fx-col z-fx-start-center"
          [ngClass]="'z-size-' + (ss.viewSize | async)"
          [no]="no"
          [questionData]="questionData"
          [groupData]="groupData | async"
          [answerValue]="answerValue | sliderAnswer"
          (dragChange)="dragChange.emit($event)"
          (answerReady)="onAnswerReady()"
          (answerChange)="onAnswerChange($event ? $event.toString() : null)"
        ></slider-1d>
      }
      @case (Questions.SLIDER_NPS) {
        <slider-nps
          class="z-fx-auto z-fx-col z-fx-start-center"
          [ngClass]="'z-size-' + (ss.viewSize | async)"
          [no]="no"
          [questionData]="questionData"
          [groupData]="groupData | async"
          [answerValue]="answerValue | sliderAnswer"
          (dragChange)="dragChange.emit($event)"
          (answerReady)="onAnswerReady()"
          (answerChange)="onAnswerChange($event ? $event.toString() : null)"
        ></slider-nps>
      }
      @case (Questions.SLIDER_E_NPS) {
        <slider-e-nps
          class="z-fx-auto z-fx-col z-fx-start-center"
          [ngClass]="'z-size-' + (ss.viewSize | async)"
          [no]="no"
          [questionData]="questionData"
          [groupData]="groupData | async"
          [answerValue]="answerValue | sliderAnswer"
          (dragChange)="dragChange.emit($event)"
          (answerReady)="onAnswerReady()"
          (answerChange)="onAnswerChange($event ? $event.toString() : null)"
        ></slider-e-nps>
      }
      @case (Questions.SLIDER_1R) {
        <slider-1r
          class="z-fx-auto z-fx-col z-fx-start-center"
          [ngClass]="'z-size-' + (ss.viewSize | async)"
          [questionData]="questionData"
          [answerValue]="answerValue | sliderAnswer"
          (dragChange)="dragChange.emit($event)"
          (answerReady)="onAnswerReady()"
          (answerChange)="onAnswerChange($event ? $event.join(';') : null)"
        ></slider-1r>
      }
      @case (Questions.INFO_TEXT) {
        <input-info
          [ngClass]="'z-input-wrapper z-size-' + (ss.viewSize | async)"
          [isActive]="active"
          [answer]="!!answerValue"
          [questionData]="questionData"
          (answerChange)="onAnswerChange($event)"
        ></input-info>
      }
      @case (Questions.GROUP_CARDS) {
        <input-info
          [ngClass]="'z-input-wrapper z-size-' + (ss.viewSize | async)"
          [isActive]="active"
          [answer]="!!answerValue"
          [questionData]="questionData"
          (answerChange)="onAnswerChange($event)"
        ></input-info>
      }
      @case (Questions.GROUP_SCORED) {
        <input-info
          [ngClass]="'z-input-wrapper z-size-' + (ss.viewSize | async)"
          [isActive]="active"
          [answer]="!!answerValue"
          [questionData]="questionData"
          (answerChange)="onAnswerChange($event)"
        ></input-info>
      }
      @case (Questions.INPUT_DROPDOWN) {
        <input-dropdown
          [ngClass]="'z-input-wrapper z-size-' + (ss.viewSize | async)"
          [isActive]="active"
          [placeholder]="questionData.inputField?.hint | translateText: 'inputFieldHint' : questionData"
          [answer]="answerValue"
          [questionData]="questionData"
          (answerChange)="onAnswerChange($event)"
          (answerReady)="onAnswerReady()"
        ></input-dropdown>
      }
      @case (Questions.INPUT_NUMERIC) {
        <input-dropdown
          [ngClass]="'z-input-wrapper z-size-' + (ss.viewSize | async)"
          [isActive]="active"
          [placeholder]="questionData.inputField?.hint | translateText: 'inputFieldHint' : questionData"
          [answer]="answerValue"
          [questionData]="questionData"
          (answerChange)="onAnswerChange($event)"
          (answerReady)="onAnswerReady()"
        ></input-dropdown>
      }
      @case (Questions.CHOICE_TEXT) {
        <ng-container [ngTemplateOutlet]="inputChoice"></ng-container>
      }
      @case (Questions.CHOICE_MULTI) {
        <ng-container [ngTemplateOutlet]="inputChoice"></ng-container>
      }
      @case (Questions.CHOICE_SINGLE) {
        <ng-container [ngTemplateOutlet]="inputChoice"></ng-container>
      }
      @case (Questions.CHOICE_PICTURE) {
        <input-choice-picture
          [ngClass]="'z-input-wrapper z-size-' + (ss.viewSize | async)"
          [placeholder]="questionData.inputField?.hint | translateText: 'inputFieldHint' : questionData"
          [answer]="answerValue"
          [questionData]="questionData"
          [isActive]="active"
          (answerChange)="onAnswerChange($event)"
          (answerReady)="onAnswerReady()"
        ></input-choice-picture>
      }
      @case (Questions.INPUT_CHECKBOX) {
        <input-checkbox
          [ngClass]="'z-input-wrapper z-size-' + (ss.viewSize | async)"
          [isActive]="active"
          [placeholder]="questionData.inputField?.hint | translateText: 'inputFieldHint' : questionData"
          [answer]="answerValue"
          [questionData]="questionData"
          [defaultAnswer]="questionData.inputField?.value === 'true'"
          (answerChange)="onAnswerChange($event)"
        ></input-checkbox>
      }
      @case (Questions.INPUT_PHONE) {
        <input-phone
          [ngClass]="'z-input-wrapper z-size-' + (ss.viewSize | async)"
          [isActive]="active"
          [placeholder]="questionData.inputField?.hint | translateText: 'inputFieldHint' : questionData"
          [questionData]="questionData"
          [answer]="answerValue != null ? answerValue.toString() : null"
          (waitNext)="waitNext.next($event)"
          (answerReady)="onAnswerReady()"
          (answerChange)="onAnswerChange($event)"
        ></input-phone>
      }
      @case (Questions.FILE_UPLOAD) {
        <file-upload
          [ngClass]="'z-input-wrapper z-size-' + (ss.viewSize | async)"
          [isActive]="active"
          [answer]="answerValue"
          [questionData]="questionData"
          (answerChange)="onAnswerChange($event)"
        ></file-upload>
      }
      @case (Questions.AI_INTERVIEWER) {
        <ai-interviewer
          [ngClass]="'z-input-wrapper z-size-' + (ss.viewSize | async)"
          [isActive]="active"
          [placeholder]="questionData.inputField?.hint | translateText: 'inputFieldHint' : questionData"
          [questionData]="questionData"
          [answerValue]="answerValue"
          (answerChange)="onAnswerChange($event)"
          (saveSummaries)="saveSummaries($event)"
        ></ai-interviewer>
      }
      @case (Questions.ESKO_WHY_FINDER) {
        <why-finder
          [ngClass]="'z-input-wrapper z-size-' + (ss.viewSize | async)"
          [isActive]="active"
          [isLast]="isLast"
          [placeholder]="questionData.inputField?.hint | translateText: 'inputFieldHint' : questionData"
          [questionData]="questionData"
          [answerValue]="answerValue"
          (answerChange)="onAnswerChange($event)"
          (saveSummaries)="saveSummaries($event)"
          (nextQuestion)="nextQuestion.emit()"
        ></why-finder>
      }
      @default {
        <input-simple
          [ngClass]="'z-input-wrapper z-size-' + (ss.viewSize | async)"
          [isActive]="active"
          [placeholder]="questionData.inputField?.hint | translateText: 'inputFieldHint' : questionData"
          [questionData]="questionData"
          [answer]="answerValue != null ? answerValue.toString() : null"
          (answerChange)="onAnswerChange($event)"
        ></input-simple>
      }
    }
  </div>
  <ng-template #inputChoice>
    <input-choice
      [ngClass]="'z-input-wrapper z-size-' + (ss.viewSize | async)"
      [isActive]="active"
      [placeholder]="questionData.inputField?.hint | translateText: 'inputFieldHint' : questionData"
      [answer]="answerValue"
      [questionData]="questionData"
      (answerChange)="onAnswerChange($event)"
      (answerReady)="onAnswerReady()"
    ></input-choice>
  </ng-template>
}
